/* istanbul ignore file */
import { useRef, useEffect } from 'react'

// This is useful when you want to fire an effect only after you've mounted.
// Useful for example if you have memoized objects you want to export from
// custom hooks but only when they change after the initial construction
const useUpdateEffect = (effect, deps) => {
  const mounted = useRef(false)

  useEffect(() => {
    if (mounted.current) {
      return effect()
    }

    mounted.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  // Reset the mounted flag on real unmount. Without this, React 18 StrictMode's
  // dev-only mount double-invoke (setup -> cleanup -> setup) leaves
  // `mounted.current` true after the first setup, so the second setup runs
  // `effect()` on initial mount -- defeating the "skip first render" guard and
  // firing update effects (e.g. useOffsetPagination's onPageChange) spuriously.
  // Resetting here means the simulated unmount flips it back to false so the
  // second setup correctly takes the skip branch.
  useEffect(
    () => () => {
      mounted.current = false
    },
    []
  )
}

export default useUpdateEffect
